// User roles
export var UserRole;
(function (UserRole) {
    UserRole["EMPLOYEE"] = "employee";
    UserRole["DEPT_ADMIN"] = "dept_admin";
    UserRole["COMPANY_ADMIN"] = "company_admin";
    UserRole["SUPER_ADMIN"] = "super_admin";
})(UserRole || (UserRole = {}));
// User status
export var UserStatus;
(function (UserStatus) {
    UserStatus["PENDING"] = "pending";
    UserStatus["ACTIVE"] = "active";
    UserStatus["INACTIVE"] = "inactive";
})(UserStatus || (UserStatus = {}));
// Game status
export var GameStatus;
(function (GameStatus) {
    GameStatus["DRAFT"] = "draft";
    GameStatus["ACTIVE"] = "active";
    GameStatus["COMPLETED"] = "completed";
    GameStatus["ARCHIVED"] = "archived";
})(GameStatus || (GameStatus = {}));
// Claim status
export var ClaimStatus;
(function (ClaimStatus) {
    ClaimStatus["PENDING"] = "pending";
    ClaimStatus["APPROVED"] = "approved";
    ClaimStatus["REJECTED"] = "rejected";
})(ClaimStatus || (ClaimStatus = {}));
// Activity event types
export var ActivityEventType;
(function (ActivityEventType) {
    ActivityEventType["CLAIM_CREATED"] = "claim_created";
    ActivityEventType["CLAIM_APPROVED"] = "claim_approved";
    ActivityEventType["CLAIM_REJECTED"] = "claim_rejected";
    ActivityEventType["BINGO_LINE"] = "bingo_line";
    ActivityEventType["GAME_STARTED"] = "game_started";
    ActivityEventType["GAME_ENDED"] = "game_ended";
    ActivityEventType["REVEAL_STARTED"] = "reveal_started";
})(ActivityEventType || (ActivityEventType = {}));
// Reveal status
export var RevealStatus;
(function (RevealStatus) {
    RevealStatus["SCHEDULED"] = "scheduled";
    RevealStatus["ACTIVE"] = "active";
    RevealStatus["COMPLETED"] = "completed";
})(RevealStatus || (RevealStatus = {}));
// Difficulty levels
export var Difficulty;
(function (Difficulty) {
    Difficulty["EASY"] = "easy";
    Difficulty["MEDIUM"] = "medium";
    Difficulty["HARD"] = "hard";
})(Difficulty || (Difficulty = {}));
// Visibility scope
export var VisibilityScope;
(function (VisibilityScope) {
    VisibilityScope["DEPARTMENT"] = "department";
    VisibilityScope["TENANT"] = "tenant";
})(VisibilityScope || (VisibilityScope = {}));
// Domain routing mode
export var DomainRoutingMode;
(function (DomainRoutingMode) {
    DomainRoutingMode["PATH"] = "path";
    DomainRoutingMode["SUBDOMAIN"] = "subdomain";
    DomainRoutingMode["CUSTOM"] = "custom";
})(DomainRoutingMode || (DomainRoutingMode = {}));
// Leave request status
export var LeaveStatus;
(function (LeaveStatus) {
    LeaveStatus["PENDING"] = "pending";
    LeaveStatus["APPROVED"] = "approved";
    LeaveStatus["REJECTED"] = "rejected";
    LeaveStatus["CANCELLED"] = "cancelled";
})(LeaveStatus || (LeaveStatus = {}));
// Half day type
export var HalfDayType;
(function (HalfDayType) {
    HalfDayType["FIRST_HALF"] = "first_half";
    HalfDayType["SECOND_HALF"] = "second_half";
})(HalfDayType || (HalfDayType = {}));
